/**
 * Builds the COMPLETE label set OPAL's `StepperNavigation` requires (R69).
 *
 * The component ships no defaults on purpose — it has no i18n of its own, so a partial map would
 * put English words into a French or Dutch aria-label by omission, with no raw key to notice. Both
 * consumers therefore build from here rather than each restating the seven `common.stepper.*` keys:
 * a state added to `StepperNavigationStepState` then breaks the build in one place instead of
 * silently going unlabelled in every stepper that forgot it.
 */
export function buildStepperLabels(t) {
    return {
        step: t("common.stepper.step"),
        of: t("common.stepper.of"),
        state: {
            upcoming: t("common.stepper.state.upcoming"),
            active: t("common.stepper.state.active"),
            completed: t("common.stepper.state.completed"),
            error: t("common.stepper.state.error"),
            disabled: t("common.stepper.state.disabled"),
        },
    };
}
